import { useCallback, useEffect, useState } from 'react';

const useIsVisible = (targetRef, options = {}) => {
  const [isVisible, setIsVisible] = useState(false);
  const callbackFunction = useCallback((entries) => {
    const [entry] = entries;
    setIsVisible(entry.isIntersecting);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(callbackFunction, options);
    const currentTarget = targetRef.current;
    if (currentTarget) observer.observe(currentTarget);
    return () => {
      if (currentTarget) observer.unobserve(currentTarget);
    };
  }, [targetRef, callbackFunction, options]);

  return { isVisible };
};

export default useIsVisible;
